import { createSvgIcon } from '@material-ui/core/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M12 5.292c-4.549 0-8.25 2.776-8.25 6.188 0 1.703.898 3.288 2.526 4.463.318.231.489.481.525.765.066.528-.348 1.035-.35 1.038a.515.515 0 0 0 .252.83c.042.012.482.131 1.083.131.792 0 1.862-.218 2.672-1.156.506.071 1.021.115 1.541.115 4.549 0 8.25-2.776 8.25-6.188s-3.701-6.187-8.25-6.187z"
}), 'MessageFilled');